import React from 'react';
import {Location} from "../../types/location";
import {useTranslation} from "../../hooks/useTranslation";
import {Mode} from "../../enum/mode";

type MapListItemProps = {
    location: Location,
    mode: Mode
}

export function MapListItem({location, mode}: MapListItemProps) {
    const translate = useTranslation();

    return (
        <>
            <div className={'locationElement'}>
                <div className={'locationName'}>
                    {mode !== Mode.SINGLE
					? <a href={location.detail}><h2>{location.name}</h2></a>
					: <h2>{location.name}</h2>
                    }
                </div>
                <div className={'locationAddress'} dangerouslySetInnerHTML={{__html: location.address}}/>
                {mode !== Mode.SINGLE &&
                    <div className={'locationDetailLink'}>
                        <a className={'button'} href={location.detail}>
                            {translate('detail_link')}
                            <span className={'right'}></span>
                        </a>
                    </div>
                }
            </div>
        </>
    );
}
